import { Controller } from '@hotwired/stimulus';

const FEEDBACK_DELAY = 2000;

export default class extends Controller {
  static targets = ['button'];

  static values = { value: String, copied: String };

  disconnect() {
    clearTimeout(this.timeout);
  }

  async copy() {
    const label = this.buttonTarget.getAttribute('aria-label');

    await navigator.clipboard.writeText(this.valueValue);

    this.#tell(true, this.copiedValue);
    this.timeout = setTimeout(() => this.#tell(false, label), FEEDBACK_DELAY);
  }

  #tell(copied, label) {
    this.buttonTarget.querySelector('[data-role="idle"]').classList.toggle('hidden', copied);
    this.buttonTarget.querySelector('[data-role="done"]').classList.toggle('hidden', !copied);

    this.buttonTarget.setAttribute('aria-label', label);
    this.buttonTarget.setAttribute('title', label);
  }
}
